// useSideNavItems.js
// Hook that builds nav items from Redux state.
import { useMemo } from "react";
import { useSelector } from "react-redux";

import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PeopleIcon from "@mui/icons-material/People";
import ArticleIcon from "@mui/icons-material/Article";

import TreatmentWellsList from "./TreatmentWellsList";

export function useSideNavItems() {
  const {
    filter,
    cartofactWells,
    selectedTreatmentWells,
    ...fpzState
  } = useSelector(state => state.fpzReducer);

  const offsetSelectedCount = selectedTreatmentWells.reduce((sum, treatment) => {
    if (!Array.isArray(treatment.offsetWells)) return sum;
    return sum + treatment.offsetWells.length;
  }, 0);

  const hasVerifiedOffsetWell = selectedTreatmentWells.some(treatment =>
    Array.isArray(treatment.offsetWells) &&
    treatment.offsetWells.some(offset => offset.verified === true)
  );

  const hasContacts = useSelector(
    (state) => (state.contactsReducer?.contacts?.length || 0) > 0
  );

  const offsetsEnabled = selectedTreatmentWells.length > 0;
  const contactsEnabled = hasVerifiedOffsetWell; // enabled if any offsets have been verified
  const reportsEnabled = offsetsEnabled && hasVerifiedOffsetWell;

  return useMemo(
    () => [
      {
        label: `Treatment Wells${(selectedTreatmentWells && selectedTreatmentWells.length) ? ` (${selectedTreatmentWells.length})` : ""}`,
        path: "/app/treatment",
        exact: true,
        icon: <OilBarrelIcon />,
        disabled: false,
        panel: <TreatmentWellsList />,
      },
      {
        label: `Offset Wells${offsetSelectedCount ? ` (${offsetSelectedCount})` : ""}`,
        path: "/app/offsets",
        icon: <AssessmentIcon />,
        disabled: !offsetsEnabled,
        secondary: offsetsEnabled ? "Select offsets" : "Select treatment first",
      },
      {
        label: "Contacts",
        path: "/app/contacts",
        icon: <PeopleIcon />,
        disabled: !contactsEnabled,
        secondary: hasContacts ? "Manage" : "",
      },
      {
        label: "Report",
        path: "/app/report",
        icon: <ArticleIcon />,
        disabled: !reportsEnabled,
        secondary: reportsEnabled ? "Generate" : "Complete selections",
      },
    ],
    [
      selectedTreatmentWells,
      offsetSelectedCount,
      hasContacts,
      offsetsEnabled,
      contactsEnabled,
      reportsEnabled,
    ]
  );
}
